/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import './searchBar.css';
import PropTypes from 'prop-types';
import CustomIcons from '../../../utils/icons';
/**
 *
 * @param {object} props - required props in search bar component
 * @returns {React.ReactElement} - returns the search bar component
 */
const SearchBar = (props) => {
  const { handleChange, handleClear, showInput, iconClick } = props;
  const [showBox, setShowBox] = React.useState(showInput);
  const [showIcon, setShowIcon] = React.useState(false);
  const [searchText, setSearchText] = React.useState('');
  /**
   *@param {event} e event
   */
  const changeIcon = (e) => {
    setShowIcon(e.target.value !== '');
    setSearchText(e.target.value);
  };
  /**
   *
   */
  const onCrossClick = () => {
    if (iconClick) {
      setShowIcon(false); 
      setShowBox(true);
      setSearchText('');
    } else setShowIcon(false);
  };
  const onSearchIconClick = () => {
    if (iconClick) {
      setShowBox(true);
    }
  };
  return (
    <div className="view_search">
      <div className="searchDiv">
        {showBox && (
          <input
            type="search"
            value={searchText}
            placeholder="Search"
            onChange={(e) => {
              handleChange(e);
              changeIcon(e);
            }}
            className="search_input"
          />
        )}
        {!showIcon && (
          <img
            src={CustomIcons.Search}
            alt="Search"
            className="searchIcon"
            onClick={onSearchIconClick}
          />
        )}
        {showIcon && (
          <img
            src={CustomIcons.CrossIcon}
            alt="Search"
            className="crossIcon"
            onClick={() => {
          
              onCrossClick();
              handleClear();
            }}
          />
        )}
      </div>
    </div>
  );
};
export default SearchBar;
SearchBar.propTypes = {
  handleChange: PropTypes.func,
  handleClear: PropTypes.func,
  showInput: PropTypes.bool,
  iconClick: PropTypes.bool,
};
SearchBar.defaultProps = {
  handleChange: () => {},
  handleClear: () => {},
  showInput: true,
  iconClick: true,
};
